import React from 'react';
import { Box, Text } from '@medely/ui-kit';
import { config } from '@mp/config';
import { HelpCenterLink } from '@mp/components/helpCenterLink';

export const MedelyInformationBox = () => {
  return (
    <Box py={4}>
      <Text size="m">
        By proceeding, I am also consenting to receive calls or SMS messages about shifts and
        assignments from Medely. Message and data rates may apply. Message frequency varies. Text
        &quot;HELP&quot; for help. Text &quot;STOP&quot; to opt out.{' '}
        <HelpCenterLink text="Medely SMS Terms" url={config.help.sms} /> and{' '}
        <HelpCenterLink text="Privacy Policy" url={config.help.privacyPolicy} />.
      </Text>
    </Box>
  );
};
